/**
 * @file cabinet-theme-boot.ts
 * @description Тема кабинета до первого кадра (phase19.29; phase19.31 —
 * палитра из данных).
 *
 * `main.tsx` вызывает `bootCabinetTheme()` ДО рендера: на <html> ставятся
 * правила кабинетов (`data-ui="console"`) и палитра по адресу страницы —
 * для кабинета магазина из кэша палитры этого магазина (если он есть), для
 * всего остального — «Commora» из пакета. Так при перезагрузке нет вспышки
 * чужих цветов, пока монтируется каркас; дальше палитрой управляют каркасы
 * (`useCabinetTheme` — платформа и вход, `useShopCabinetTheme` — магазин).
 *
 * После навигаций (`syncBootTheme`) на адресах вне кабинета магазина
 * ставится «Commora» — например, магазин → «Выбор кабинета» или «Нет
 * доступа». Адреса магазина не трогаем: палитру своего магазина ставит его
 * каркас (кэш, затем ответ сервера).
 */

import { applyCommoraPalette, applyPalette, bootPaletteForPath, shopSlugFromPath } from "./cabinet-palette";

/** Путь без base приложения (`/admin/` в dev, `/` в сборке). */
export function routePathname(pathname: string, base: string = import.meta.env.BASE_URL): string {
  const prefix = base.endsWith("/") ? base.slice(0, -1) : base;
  return prefix && pathname.startsWith(prefix) ? pathname.slice(prefix.length) || "/" : pathname;
}

/** До первого рендера: правила кабинетов и палитра по адресу страницы. */
export function bootCabinetTheme(): void {
  applyPalette(bootPaletteForPath(routePathname(window.location.pathname)));
}

/** После навигации: вне кабинета магазина — «Commora». */
export function syncBootTheme(pathname: string): void {
  if (!shopSlugFromPath(pathname)) applyCommoraPalette();
}
